import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

import { editorConfig } from 'src/app/models/editorconfig';
import { Homepage } from 'src/app/models/homepage';
import { HomepageService } from 'src/app/services/homepage.service';

import { EditorComponent } from '../../editor/editor.component';
@Component({
  selector: 'app-admin-homepage',
  templateUrl: './admin-homepage.component.html',
  styleUrls: ['./admin-homepage.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, MatButtonModule, EditorComponent]
})
export class AdminHomepageComponent implements OnInit {
  private homepageService = inject(HomepageService);
  private formBuilder = inject(UntypedFormBuilder);
  formGroup!: UntypedFormGroup;
  homePage!: Homepage;
  editorConfig = {};

  ngOnInit() {
    this.start();
    this.editorConfig = editorConfig.standard;
  }

  start() {
    this.homepageService.getHomepage().subscribe({
      next: (homepage) => {
        this.homePage = homepage;
        this.createForm();
      }
    });
  }

  async createForm() {
    const homepage = this.homePage ? await this.homePage : ({} as Homepage);
    this.formGroup = this.formBuilder.group({
      id: [homepage && homepage.id ? homepage.id : ''],
      content: [homepage && homepage.content ? homepage.content : '']
    });
  }

  save() {
    const homePage = this.formGroup.value as Homepage;
    this.homepageService.postDataById(homePage).subscribe({
      next: (hPage: Homepage) => {
        if (this.formGroup.value.id === '@New') {
          this.formGroup.value.id = hPage.id;
        }
      }
    });
  }
}
